"use strict";

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  Input,
  MultiSelect,
  rem,
  Select,
  Text,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import {
  useDebouncedCallback,
  useDebouncedValue,
  useDisclosure,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconBuildingWarehouse,
  IconFileExport,
  IconFolders,
  IconListDetails,
  IconPackage,
  IconSearch,
  IconTimeDuration15,
} from "@tabler/icons-react";
import {
  ColDef,
  GridReadyEvent,
  IDatasource,
  IGetRowsParams,
  InfiniteRowModelModule,
  ModuleRegistry,
} from "ag-grid-community";
import { AgGridReact, CustomCellRendererProps } from "ag-grid-react";
import dayjs from "dayjs";
import {
  paginationPageSizeSelector,
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_POS } from "../../../config";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { MessageResponse } from "../../../model/MessageResponse";

// Đăng ký module Infinite Row Model
ModuleRegistry.registerModules([InfiniteRowModelModule]);
export interface FifoViolationDto {
  ngayCtDh: string;
  maPxk: string | null;
  soDh: string;
  maVach: string | null;
  maSp: string | null;
  tenSp: string | null;
  giaBan: number | null;
  ngayXuatBan: string | null;
  ngayNhapKho: string | null;
  soNgayLuuKhoBan: number | null;
  ngayNhapMua: string | null;
  luuKhoMuaHang: number | null;
  maKh: string | null;
  tenKh: string | null;
  sdtKh: string | null;
  maNvgd: string | null;
  tenNvgd: string | null;
  maNvkho: string | null;
  tenNvkho: string | null;
  maCn: string;
  tenCn: string;
  maKho: string;
  tenKho: string;
  dienGiai: string | null;
  dienGiaiCtGoc: string | null;
  supplier: string | null;
  giaNhap: number | null;
  lkMaVach: string;
  lkNgayNhapNcc: string;
  lkLuuKhoMuaHang: number;
  lkNgayNhap: string;
  lkNgayLuuKhoDc: number;
  lkNgayNhapCn: string | null;
  lkMaKho: string | null;
}

const GetWarningFIFO = () => {
  // Không cần state rowData hay loading thủ công nữa, AG Grid tự quản lý
  const gridRef = useRef<AgGridReact<any>>(null);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(750);

  // Data cho các ô select
  const [dataBranchCode, setDataBranchCode] = useState<any[]>([]);
  const [dataInvCode, setDataInvCode] = useState<any[]>([]);
  const [dataItem, setDataItem] = useState<any[]>([]);
  const [dataCatSegment3c, setDataCatSegment3c] = useState<ComboboxItem[]>([]);
  const [dataCatSegment4d, setDataCatSegment4d] = useState<ComboboxItem[]>([]);
  const [dataCatSegment5e, setDataCatSegment5e] = useState<ComboboxItem[]>([]);

  const [search4d, setSearch4d] = useState<string>("");
  const [debounceSearch4d] = useDebouncedValue<string>(search4d, 500);
  const [search5e, setSearch5e] = useState<string>("");
  const [debounceSearch5e] = useDebouncedValue<string>(search5e, 500);
  //NCC
  const [dataVendor, setDataVendor] = useState<ComboboxItem[]>([]);
  // Search item logic
  const lastItemSearchRef = useRef("");
  const debouncedGetDataItem = useDebouncedCallback((value: string) => {
    const trimmed = value.trim();
    if (trimmed.length >= 2 && trimmed !== lastItemSearchRef.current) {
      lastItemSearchRef.current = trimmed;
      getDataItem(trimmed);
    }
  }, 500);
  const [loading, setLoading] = useState(false);

  const containerStyle = useMemo(
    () => ({ width: "100%", height: height }),
    [height],
  );
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const sizeGrid = { base: 12, sm: 6, md: 6, lg: 2 };
  const [visible, { toggle, close, open }] = useDisclosure(false);

  // Form Filter
  const form = useForm<{
    KeySearch: string;
    MaKho: string[];
    MaVatTu: string[];
    FromDate: string | null;
    ToDate: string | null;
    MaVt: string | null;
    MaCn: string[];
    MaNcc: string[];
    Onlyfirstin: string;
    MaLoai: string[] | null;
    MaChung: string[] | null;
    MaNhom: string[] | null;
  }>({
    initialValues: {
      KeySearch: "",
      MaKho: [],
      MaVatTu: [],
      FromDate: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
      ToDate: dayjs().format("YYYY-MM-DD"),
      MaVt: null,
      MaCn: [],
      MaNcc: [],
      Onlyfirstin: "N",
      MaLoai: [],
      MaChung: [],
      MaNhom: [],
    },
  });

  // Auto resize height
  useEffect(() => {
    const updateHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const newHeight = window.innerHeight - (210 + headerHeight);
      setHeight(newHeight);
    };
    setTimeout(updateHeight, 0);
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  // --- LOGIC GỌI API (Được gọi bởi Datasource) ---
  const fetchData = async (startRow: number, endRow: number) => {
    const fromDate = new Date(form.getValues().FromDate || "");
    const toDate = new Date(form.getValues().ToDate || "");

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setDate(fromDate.getDate() + 40);

    if (toDate > maxAllowedDate) {
      NotificationExtension.Fails(
        "Chỉ được phép lọc dữ liệu trong khoảng 40 ngày !",
      );
    } else if (!form.getValues().MaCn || form.getValues().MaCn?.length === 0) {
      NotificationExtension.Fails(
        "Vui lòng chọn chi nhánh trước khi tìm kiếm !",
      );
    } else {
      try {
        const skip = startRow;
        const take = endRow - startRow;
        const values = form.getValues();

        const params = new URLSearchParams();
        params.append("Skip", skip.toString());
        params.append("Take", take.toString());

        if (values.KeySearch)
          params.append("KeySearch", values?.KeySearch?.trim());
        if (values.FromDate) params.append("FromDate", values.FromDate);
        if (values.ToDate) params.append("ToDate", values.ToDate);
        if (values.Onlyfirstin)
          params.append("OnlyFirstIn", values.Onlyfirstin);

        if (values.MaNcc && values.MaNcc.length > 0) {
          values.MaNcc.forEach((k: string) => params.append("MaNcc", k));
        }

        if (values.MaCn && values.MaCn.length > 0) {
          values.MaCn.forEach((k: string) => params.append("MaCn", k));
        }

        if (values.MaKho && values.MaKho.length > 0) {
          values.MaKho.forEach((k: string) => params.append("MaKho", k));
        }

        if (values.MaLoai && values.MaLoai.length > 0) {
          values.MaLoai.forEach((k: string) => params.append("MaLoai", k));
        }

        if (values.MaChung && values.MaChung.length > 0) {
          values.MaChung.forEach((k: string) => params.append("MaChung", k));
        }

        if (values.MaNhom && values.MaNhom.length > 0) {
          values.MaNhom.forEach((k: string) => params.append("MaNhom", k));
        }

        if (values.MaVt) {
          values.MaVt.split(";")
            .map((s) => s?.trim())
            .filter(Boolean)
            .forEach((v) => params.append("MaVt", v));
        }

        let url = `/api/v1/FifoViolation/get-list?${params.toString()}`;
        const response =
          await repositoryPos.get<MessageResponse<FifoViolationDto[]>>(url);
        return response;
      } catch (error) {
        console.error("API Error:", error);
        return null;
      }
    }
  };

  // --- TẠO DATASOURCE CHO INFINITE ROW MODEL ---
  const getDatasource = useCallback((): IDatasource => {
    return {
      getRows: async (params: IGetRowsParams) => {
        const { startRow, endRow } = params;
        gridRef.current?.api?.showLoadingOverlay();

        try {
          const response = await fetchData(startRow, endRow);

          if (response && response.success) {
            const data = response.data || [];
            const totalCount = (response as any).totalCount ?? 0;
            gridRef.current?.api?.hideOverlay();
            params.successCallback(data, totalCount);
          } else {
            params.failCallback();
            gridRef.current?.api?.hideOverlay();
          }
        } catch (e) {
          params.failCallback();
          gridRef.current?.api?.hideOverlay();
        }
      },
    };
  }, [form.getValues()]); // Re-create datasource khi form values thay đổi (thực ra ko cần thiết nếu dùng setDatasource ở handleSearch)

  // --- SỰ KIỆN BẤM TÌM KIẾM ---
  const handleSearch = useCallback(() => {
    form.setErrors({});
    const values = form.getValues();
    console.log(values);
    if (
      values.FromDate &&
      values.ToDate &&
      dayjs(values.FromDate).isAfter(dayjs(values.ToDate))
    ) {
      form.setFieldError(
        "FromDate",
        "Ngày bắt đầu phải nhỏ hơn hoặc bằng ngày kết thúc",
      );
      return;
    }
    if (gridRef.current && gridRef.current.api) {
      // Set lại datasource mới sẽ kích hoạt Grid reset về trang 1 và gọi lại getRows với filter mới
      gridRef.current.api.setGridOption("datasource", getDatasource());
    }
  }, [form, getDatasource]);

  // --- ON GRID READY ---
  const onGridReady = useCallback(
    (params: GridReadyEvent) => {
      // Gán datasource ban đầu
      params.api.setGridOption("datasource", getDatasource());
    },
    [getDatasource],
  );

  // --- CÁC HÀM TIỆN ÍCH KHÁC GIỮ NGUYÊN ---
  const getRowId = useCallback((params: any) => {
    const d = params.data || {};
    return (
      `${d.maVT}_${d.serial}_${d.soCTNhap}`.replace(/(^_+|_+$)/g, "") ||
      Math.random().toString()
    );
  }, []);

  const getRowStyle = useCallback((params: any) => {
    if (params.node.rowPinned) {
      return {
        backgroundColor: "#e7f5ff",
        fontWeight: 700,
        fontSize: "14px",
        borderTop: "3px solid #15aabf",
      };
    }
    return undefined;
  }, []);

  const columnDefs = useMemo<ColDef[]>(
    () => [
      {
        headerName: "STT",
        valueGetter: (params) => {
          if (
            params.node?.rowIndex !== null &&
            params.node?.rowIndex !== undefined
          ) {
            return params.node.rowIndex + 1;
          }
          return null;
        },
        width: 100,
        pinned: "left",
      },
      {
        field: "soDh",
        headerName: "Số đơn hàng",
        filter: "agTextColumnFilter",
        width: 140,
        pinned: "left",
      },
      {
        field: "maPxk",
        headerName: "Mã PXK",
        filter: "agTextColumnFilter",
        width: 140,
      },
      {
        field: "ngayCtDh",
        headerName: "Ngày CT đơn hàng",
        filter: "agTextColumnFilter",
        width: 190,
        valueFormatter: (p: any) =>
          p.value ? formatDateTransfer(p.value) : "",
      },
      {
        field: "maVach",
        headerName: "Mã vạch",
        filter: "agTextColumnFilter",
        width: 140,
      },
      {
        field: "maSp",
        headerName: "Mã sản phẩm",
        filter: "agTextColumnFilter",
        width: 130,
      },
      {
        field: "tenSp",
        headerName: "Tên sản phẩm",
        filter: "agTextColumnFilter",
        minWidth: 250,
      },
      {
        field: "maLoai",
        headerName: "Loại hàng",
        filter: "agTextColumnFilter",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {[
                String(params.value || "").trim(),
                String(params?.data?.tenLoai || "").trim(),
              ]
                .filter((i) => i && String(i).length > 0)
                .join(" - ")}
            </Text>
          );
        },
        width: 250,
      },
      {
        field: "maChung",
        headerName: "Chủng hàng",
        filter: "agTextColumnFilter",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {[
                String(params.value || "").trim(),
                String(params?.data?.tenChung || "").trim(),
              ]
                .filter((i) => i && String(i).length > 0)
                .join(" - ")}
            </Text>
          );
        },
        width: 250,
      },
      {
        field: "maNhom",
        headerName: "Nhóm hàng",
        filter: "agTextColumnFilter",
        cellRenderer: (params: CustomCellRendererProps) => {
          return (
            <Text mt={10}>
              {[
                String(params.value || "").trim(),
                String(params?.data?.tenNhom || "").trim(),
              ]
                .filter((i) => i && String(i).length > 0)
                .join(" - ")}
            </Text>
          );
        },
        width: 250,
      },
      {
        field: "giaBan",
        headerName: "Giá bán",
        filter: "agTextColumnFilter",
        width: 120,
        valueFormatter: (p: any) =>
          p.value ? Number(p.value).toLocaleString() : "",
      },
      {
        field: "giaNhap",
        headerName: "Giá nhập",
        filter: "agTextColumnFilter",
        width: 120,
        valueFormatter: (p: any) =>
          p.value ? Number(p.value).toLocaleString() : "",
      },
      {
        field: "ngayXuatBan",
        headerName: "Ngày xuất bán",
        filter: "agTextColumnFilter",
        width: 130,
        valueFormatter: (p: any) =>
          p.value ? formatDateTransfer(p.value) : "",
      },
      {
        field: "ngayNhapKho",
        headerName: "Ngày nhập kho",
        filter: "agTextColumnFilter",
        width: 130,
        valueFormatter: (p: any) =>
          p.value ? formatDateTransfer(p.value) : "",
      },
      {
        field: "soNgayLuuKhoBan",
        headerName: "Lưu kho bán",
        filter: "agTextColumnFilter",
        width: 120,
        valueFormatter: (p: any) =>
          p.value != null ? Number(p.value).toLocaleString() : "",
      },
      {
        field: "ngayNhapMua",
        headerName: "Ngày nhập mua",
        filter: "agTextColumnFilter",
        width: 130,
        valueFormatter: (p: any) =>
          p.value ? formatDateTransfer(p.value) : "",
      },
      {
        field: "luuKhoMuaHang",
        headerName: "Lưu kho mua",
        filter: "agTextColumnFilter",
        width: 120,
        valueFormatter: (p: any) =>
          p.value != null ? Number(p.value).toLocaleString() : "",
      },
      {
        field: "maKh",
        headerName: "Mã KH",
        filter: "agTextColumnFilter",
        width: 120,
      },
      {
        field: "tenKh",
        headerName: "Tên KH",
        filter: "agTextColumnFilter",
        width: 180,
      },
      {
        field: "sdtKh",
        headerName: "SĐT KH",
        filter: "agTextColumnFilter",
        width: 120,
      },
      {
        field: "supplier",
        headerName: "Nhà cung cấp",
        filter: "agTextColumnFilter",
        width: 180,
      },
      {
        field: "tenNvgd",
        headerName: "NV Giao dịch",
        filter: "agTextColumnFilter",
        width: 160,
      },
      {
        field: "tenNvkho",
        headerName: "NV Kho",
        filter: "agTextColumnFilter",
        width: 180,
      },
      {
        field: "tenCn",
        headerName: "Chi nhánh",
        filter: "agTextColumnFilter",
        width: 180,
      },
      {
        field: "tenKho",
        headerName: "Kho hàng",
        filter: "agTextColumnFilter",
        width: 250,
        cellRenderer: (p: any) => (
          <Text>
            {p.data?.maKho} - {p.data?.tenKho}
          </Text>
        ),
      },
      {
        field: "lkMaVach",
        headerName: "LK Mã vạch",
        filter: "agTextColumnFilter",
        width: 140,
      },
      {
        field: "lkNgayNhap",
        headerName: "LK Ngày nhập",
        filter: "agTextColumnFilter",
        width: 180,
        valueFormatter: (p: any) =>
          p.value ? formatDateTransfer(p.value) : "",
      },
      {
        field: "lkNgayLuuKhoDc",
        headerName: "LK Lưu kho DC",
        filter: "agTextColumnFilter",
        width: 180,
        valueFormatter: (p: any) =>
          p.value != null ? Number(p.value).toLocaleString() : "",
      },
      {
        field: "lkNgayNhapCn",
        headerName: "LK Ngày nhập CN",
        filter: "agTextColumnFilter",
        width: 180,
        valueFormatter: (p: any) =>
          p.value ? formatDateTransfer(p.value) : "",
      },
      {
        field: "lkMaKho",
        headerName: "LK Mã kho",
        filter: "agTextColumnFilter",
        width: 140,
      },
      {
        field: "dienGiai",
        headerName: "Diễn giải",
        filter: "agTextColumnFilter",
        minWidth: 200,
      },
    ],
    [],
  );

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      sortable: false, // Infinite model server-side sort hơi phức tạp, tạm tắt hoặc cần handle trong getRows
      resizable: true,
    };
  }, []);

  //Kho
  const FetchDataInvCode = async () => {
    try {
      const values = form.getValues();
      if (values.MaCn.length > 0 && dataBranchCode.length > 0) {
        const branchSelected = dataBranchCode.find(
          (x) => x.value === values.MaCn[0],
        );
        const response = await repositoryPos.get(
          `/api/v1/TblDmInventory/get-select-by-branch?branchId=${branchSelected?.id}`,
        );
        if (response && response.success) {
          const transformedData = response.data.map((item: any) => ({
            value: String(item.inventoryCode),
            label: item.inventoryCode + " - " + item.inventoryName,
          }));
          setDataInvCode(transformedData);
        } else {
          setDataInvCode([]);
        }
      } else {
        const response = await repositoryDelivery.get(
          `/api/v1/TblDmInventory/get-all?checkAuth=true`,
        );
        if (response && response.httpStatusCode === 200) {
          const transformedData = response.data
            ?.filter((i: any) => i.code && i.name)
            .map((item: any) => {
              return {
                value: item.code,
                label: item.code + " - " + item.name,
              };
            });

          setDataInvCode(transformedData);
        }
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const DataBrachCode = async () => {
    try {
      const response = await repositoryPos.get(
        `api/v1/TblDmInventory/get-select-branch?auth=true`,
      );
      if (response && response.success) {
        const transformedData = response.data
          .filter((i: any) => i.att2 && i.text)
          .map((item: any) => {
            return {
              value: item.att2,
              label: item.att2 + " - " + item.text,
              id: item.value,
            };
          });
        setDataBranchCode(transformedData);

        const branchUser =
          JSON.parse(localStorage.getItem("userLoginHeader") || "{}")
            ?.branchId || "";
        form.setFieldValue("MaCn", [
          transformedData.find((i: any) => String(i.id) === String(branchUser))
            ?.value,
        ]);

        handleSearch();
      }
    } catch (error) {
      console.error(error);
    }
  };

  //Call API NCC
  const fetchDataVendorSelect = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblVendor/get-all",
    );

    if (res && res.success) {
      const dataAPI = res.data;
      setDataVendor(
        dataAPI
          ?.filter(
            (item: any) => item.vendorCode != null && item.vendorName != null,
          )
          ?.map((item: any) => ({
            value: item.vendorCode?.toString(),
            label: `${item.vendorCode} - ${item.vendorName}`,
          })),
      );
    }
  };

  const getCatSegment3c = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment3c/get-all",
    );

    if (res && res.success) {
      let data: ComboboxItem[] = [];
      data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));

      setDataCatSegment3c(data);
    }
  };

  const getCatSegment4d = async () => {
    let url = `/api/v1/TblCatSegment4d/get-list?Skip=0&Take=50`;

    if (
      form.getValues()?.MaLoai &&
      Array.isArray(form.getValues()?.MaLoai) &&
      (form.getValues().MaLoai || []).length > 0
    ) {
      url += form
        .getValues()
        ?.MaLoai?.map((i: string) => `&listCodeSegmentString3=${i}`)
        ?.join("");
    }

    if (debounceSearch4d.length > 3) {
      url += `&KeySearch=${debounceSearch4d}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));

      setDataCatSegment4d(data);
    }
  };

  const getCatSegment5e = async () => {
    let url = `/api/v1/TblCatSegment5e/get-list?Skip=0&Take=50`;

    if (
      form.getValues()?.MaChung &&
      Array.isArray(form.getValues()?.MaChung) &&
      (form.getValues().MaChung || []).length > 0
    ) {
      url += `&ListCodeString4=${form.getValues()?.MaChung?.join(",")}`;
    }

    if (debounceSearch5e.length > 3) {
      url += `&KeySearch=${debounceSearch5e}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const data = res.data
        ?.filter((item: any) => item.codeString && item.name)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));

      setDataCatSegment5e(data);
    }
  };

  const handleCleanKeySearch = (str: string) => {
    if (typeof str !== "string") return "";
    return str.replace(/;+/g, ";").replace(/;\s*$/, "");
  };
  const getDataItem = async (keyword: string) => {
    try {
      let url;
      if (keyword.length === 0) url = `api/v1/TblItem/get-list?Skip=0&Take=100`;
      else
        url = `api/v1/TblItem/get-list?Skip=0&Take=100&ListItemCode=${keyword.toUpperCase()}`;
      const response = await repositoryPos.get(url);
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((item: any) => item.itemCode && item.itemName)
          .map((item: any) => ({
            label: item.itemCode + " - " + item.itemName,
            value: item.itemCode,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataItem(uniqueData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    DataBrachCode();
    fetchDataVendorSelect();
    getCatSegment3c();
  }, []);

  useEffect(() => {
    getCatSegment4d();
  }, [debounceSearch4d, form.getValues().MaLoai]);

  useEffect(() => {
    getCatSegment5e();
  }, [debounceSearch5e, form.getValues().MaChung]);

  useEffect(() => {
    FetchDataInvCode();
  }, [form.getValues().MaCn]);

  // ExportData Excel
  const exportDataExcel = async () => {
    open();
    try {
      const values = form.getValues();
      const payload = {
        keySearch: values.KeySearch?.trim() || "",
        sort: "",
        isOrder: true,
        active: true,
        skip: 0,
        take: 0,
        isAll: true,
        fromDate: values.FromDate ? dayjs(values.FromDate).toISOString() : null,
        toDate: values.ToDate ? dayjs(values.ToDate).toISOString() : null,
        maKho: values.MaKho?.join(",") || "",
        maVt: values.MaVt || "",
        maNcc: values.MaNcc || [],
        maCn: values.MaCn || [],
        onlyFirstIn: values.Onlyfirstin || "N",
        MaLoai: values.MaLoai || [],
        MaChung: values.MaChung || [],
        MaNhom: values.MaNhom || [],
      };

      const url = `${BASE_API_POS}/api/v1/FifoViolation/export-fifo-sll`;
      const token = localStorage.getItem("token")?.replace(/"/g, "");

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        NotificationExtension.Success("Yêu cầu xuất đã vào hàng đợi.");
      } else {
        let text = "";
        try {
          text = await response.text();
          console.error("Export failed response text:", text);
        } catch (e) {
          console.error(e);
        }
        NotificationExtension.Fails("Export Excel thất bại !");
      }
    } catch (error) {
      console.error("Error:", error);
      NotificationExtension.Fails("Export Excel thất bại !");
    } finally {
      close();
    }
  };
  return (
    <Box pos={"relative"} style={containerStyle}>
      <LoadingOverlayCustom visible={visible} />

      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px",
          overflowX: "hidden",
        }}
      >
        <Group justify="space-between" gap={0}>
          <BreadcrumbLayout1 />
          <Button
            leftSection={
              <IconFileExport style={{ width: rem(14), height: rem(14) }} />
            }
            onClick={exportDataExcel}
          >
            Export Excel
          </Button>
        </Group>
        <Grid mt={10}>
          {/* GIỮ NGUYÊN UI FILTER NHƯ CŨ */}
          <Grid.Col span={sizeGrid}>
            <Input
              placeholder="Nhập tìm kiếm"
              leftSection={<IconSearch size={20} color="#15aabf" />}
              value={form.getValues().KeySearch}
              onChange={(e) => form.setFieldValue("KeySearch", e.target.value)}
              onKeyDown={async (e) => {
                if (e.key === "Enter") handleSearch();
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chi nhánh"
              searchable
              data={dataBranchCode}
              value={
                form.getValues().MaCn[0] && String(form.getValues().MaCn[0])
                  ? String(form.getValues().MaCn[0])
                  : null
              }
              onChange={(v) => form.setFieldValue("MaCn", v ? [v] : [])}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Mã kho"
              searchable
              clearable
              data={dataInvCode}
              value={form.getValues().MaKho}
              onClick={() => {
                if (Array.isArray(dataInvCode) && dataInvCode.length === 0) {
                  FetchDataInvCode();
                }
              }}
              onChange={(v) => form.setFieldValue("MaKho", v)}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Nhập mã NCC"
              type="text"
              data={dataVendor}
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              searchable
              clearable
              value={form.getValues().MaNcc}
              onClick={() => {
                if (dataVendor.length === 0) {
                  fetchDataVendorSelect();
                }
              }}
              onChange={(v) => form.setFieldValue("MaNcc", v)}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              placeholder="Nhập mã vật tư"
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              searchable
              clearable
              data={dataItem}
              nothingFoundMessage="Không tìm thấy dữ liệu"
              value={form.getValues().MaVt}
              onSearchChange={(value) => debouncedGetDataItem(value)}
              onChange={(v) => form.setFieldValue("MaVt", v || "")}
              onClick={() => {
                if (dataItem.length === 0) {
                  getDataItem("");
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Loại hàng"
              leftSection={<IconPackage color="#15aabf" />}
              data={dataCatSegment3c}
              value={form.getValues().MaLoai || []}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => form.setFieldValue("MaLoai", e ? e : [])}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Chủng hàng"
              leftSection={<IconListDetails color="#15aabf" />}
              data={dataCatSegment4d}
              value={form.getValues().MaChung || []}
              searchValue={search4d}
              onSearchChange={setSearch4d}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => form.setFieldValue("MaChung", e ? e : [])}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Nhóm hàng"
              leftSection={<IconFolders color="#15aabf" />}
              data={dataCatSegment5e}
              value={form.getValues().MaNhom || []}
              searchValue={search5e}
              onSearchChange={setSearch5e}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => form.setFieldValue("MaNhom", e ? e : [])}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              {...form.getInputProps("FromDate")}
              value={
                form.getValues().FromDate
                  ? dayjs(form.getValues().FromDate, "YYYY-MM-DD").toDate()
                  : null
              }
              onChange={(date) =>
                form.setFieldValue(
                  "FromDate",
                  date ? dayjs(date).format("YYYY-MM-DD") : null,
                )
              }
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              {...form.getInputProps("ToDate")}
              value={
                form.getValues().ToDate
                  ? dayjs(form.getValues().ToDate, "YYYY-MM-DD").toDate()
                  : null
              }
              onChange={(date) =>
                form.setFieldValue(
                  "ToDate",
                  date ? dayjs(date).format("YYYY-MM-DD") : null,
                )
              }
            />
          </Grid.Col>
          <Grid.Col
            span={sizeGrid}
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <Checkbox
              label="Vi phạm FIFO đầu tiên"
              checked={form.getValues().Onlyfirstin === "Y"}
              onChange={(event) =>
                form.setFieldValue(
                  "Onlyfirstin",
                  event.currentTarget.checked ? "Y" : "N",
                )
              }
            />
            <Button color="blue" variant="outline" onClick={handleSearch}>
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>

      <div style={gridStyle} className={"ag-theme-quartz"}>
        <AgGridReact<FifoViolationDto>
          ref={gridRef}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          // --- CẤU HÌNH QUAN TRỌNG CHO INFINITE ROW MODEL ---
          rowModelType={"infinite"} // Chế độ load theo trang từ server
          // Kích thước mỗi lần gọi API (Take = 100)
          cacheBlockSize={100}
          // Số dòng tối đa giữ trong cache trình duyệt (tùy chỉnh để tối ưu RAM)
          maxBlocksInCache={10}
          // Hiển thị phân trang
          pagination={true}
          paginationPageSize={100} // Phải khớp hoặc là bội số của cacheBlockSize
          paginationPageSizeSelector={paginationPageSizeSelector} // [100, 200, 500]
          onGridReady={onGridReady}
          getRowId={getRowId}
          getRowStyle={getRowStyle}
          localeText={AG_GRID_LOCALE_VN}
        />
      </div>
    </Box>
  );
};
export default GetWarningFIFO;
